<template>
    <div
        class="form"
        :id="options.id"
        :class="{'title-width-auto':options.titleWidthAuto}"
        :style="options.style"
    >
        <div
            class="panel"
            v-for="(panel,index) in options.panels"
            :key="index"
            :id="panel.id"
            :class="{'no-title':!panel.title}"
        >
            <header v-if="panel.title">{{propI18N(panel.title)}}</header>
            <section>
                <div
                    class="form-group"
                    v-for="field in panel.fields"
                    :style="{width:field.width?(field.width+'px'):(1/options.columns*(field.colspan || 1)*100+'%')}"
                    :key="field"
                    :ref="'group_'+field.field"
                >
                    <template v-if="field.field">
                        <div
                            class="title"
                            :title="propI18N(field.title)"
                            :style="{width:options.titleWidth+'px',justifyContent:options.titleAlign ==='left'?'flex-start':null}"
                        >
                            <span class="text">{{propI18N(field.title)}}</span>
                        </div>
                        <span class="colon">：</span>
                        <div class="field" v-if="field.field">
                            <editor :options="field" :formData="options.data" />
                        </div>
                        <div class="field" v-else></div>
                    </template>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Gikam from "../../core/gikam-core";

export default {
    props: {
        options: Object
    },

    components: {
        editor: {
            functional: true,
            props: {
                options: Object,
                formData: Object
            },

            inject: ["form"],

            render: (h, context) => {
                let options = context.props.options;
                let tag = (options.type || "text") + "Field";
                return (
                    <tag
                        class="field-container"
                        options={context.props.options}
                        propValue={
                            options.value ||
                            Gikam.getFieldValue(
                                context.props.formData,
                                options.field
                            )
                        }
                        ref={options.field}
                        onChange={(...args) => {
                            Gikam.setFieldValue(
                                context.props.formData,
                                args[0],
                                args[1]
                            );
                            if (
                                options.onChange &&
                                context.injections.form.triggerChangeFlag ===
                                    true
                            ) {
                                options.onChange.apply(
                                    context.injections.form,
                                    args
                                );
                            }
                            if (context.injections.form.canAutoSave) {
                                const data = { id: context.props.formData.id };
                                data[args[0]] = args[1];
                                context.injections.form.autoSave(data);
                            }
                        }}
                        onAfterChoose={(...args) => {
                            if (!options.onAfterChoose) {
                                return;
                            }
                            options.onAfterChoose.apply(
                                context.injections.form,
                                args
                            );
                        }}
                        onFocus={(...args) => {
                            Gikam.trigger(
                                options,
                                "onFocus",
                                context.injections.form,
                                args
                            );
                        }}
                    ></tag>
                );
            }
        }
    },

    data() {
        return {
            rows: []
        };
    },

    methods: {
        propI18N(text) {
            return Gikam.propI18N(text);
        },

        getData() {
            this.$children.forEach(item => {
                if (item.field && Gikam.isNotEmpty(item.value)) {
                    Gikam.setFieldValue(
                        this.options.data,
                        item.field,
                        item.value
                    );
                }
            });
            return Gikam.deepExtend(this.options.data);
        }
    }
};
</script>

<style scoped>
.form {
    background-color: white;
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    padding-top: 10px;
}

.panel {
    border: 1px solid #eee;
    padding-top: 20px;
    position: relative;
    padding-right: 10px;
    margin-bottom: 10px;
}
.panel:last-child {
    margin-bottom: 0;
}

.panel.no-title {
    border: none;
    padding-top: 0;
}

.panel header {
    display: inline-block;
    position: absolute;
    left: 16px;
    top: -10px;
    padding: 0 8px;
    background-color: #fff;
    font-size: 12px;
    color: black;
    font-weight: bold;
}

.panel section {
    display: flex;
    flex-wrap: wrap;
}

.panel > section > .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.form-group .title {
    color: rgba(0, 0, 0, 0.85);
    width: 100px;
    display: flex;
    height: 30px;
    position: relative;
    align-items: center;
    justify-content: flex-end;
}

.form .form-group .title .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.form.title-width-auto .form-group .title {
    width: auto;
    padding-left: 8px;
}

.form .form-group .colon {
    color: rgba(0, 0, 0, 0.85);
}

.form .form-group .field {
    flex: 1;
    align-items: center;
    justify-content: center;
}

.form .form-group .title,
.form .form-group .field {
    height: 100%;
    overflow: hidden;
}

.field * {
    min-height: 30px;
}

/* 解决IE下min-height不被子元素继承的问题 */
.field >>> .field-container > div:not(.checkbox),
.field >>> .field-container > input {
    min-height: 30px;
}

.form >>> .sign .container.readonly {
    background-color: #f4f4f4;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-right: 40px;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
}

.panel .field >>> .readonly:not(.textarea) .readonly-text {
    display: block;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.panel .field >>> .readonly .link-text {
    display: block;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>